import { useSiteConfig } from "@context/siteConfig";
import { useTranslations } from "@context/translations";
import clsx from "clsx";
import React from "react";
import styles from "./CouponBanner.module.scss";

const CouponBanner = () => {
  const translate = useTranslations();
  const { isRtl } = useSiteConfig();

  return (
    <div
      data-testid="coupon-banner"
      className={clsx(styles.container, isRtl && styles.rtl)}
    >
      <div className={styles.couponTitle}>
        <span>{translate("coupons_title")}</span>
      </div>
    </div>
  );
};

export default CouponBanner;
